import * as React from 'react'
import { CardElement } from 'react-stripe-elements'

const CARD_ELEMENT_STYLES = {
  base: {
    'fontSize': '15px',
    'color': '#0a0a0a',
    'fontFamily': 'Mulish, "Helvetica Neue", Helvetica, Roboto, Arial, sans-serif',
    '::placeholder': {
      color: '#555555',
    },
  },
  invalid: {
    color: '#cc4b37',
  },
}

export class StripePaymentForm extends React.Component {
  public render() {
    return (
      <section className="payment-information">
        <h2>Payment Information</h2>
        <div className="stripe-payment-card-element-container">
          <CardElement
            style={CARD_ELEMENT_STYLES}
          />
        </div>
      </section>
    )
  }
}
